import { Link } from "react-router-dom";
import "./HeroTextAndImage.css"
import SponsorAndPartnerLogos from "../SponsorAndPartnerLogos/SponsorAndPartnerLogos.js";


function HeroTextAndImage(props){
    return(
        <section className={`hero-text-and-image ${props.powderBlueBackground ? 'power-blue-bg' : ''}`}>
			<div className='hero-text'>
				<h1 className="darkgreen" dangerouslySetInnerHTML={{ __html: props.titleText }} />
				{props.subtitleText && <p className="darkgreen hero-subtitle">{props.subtitleText}</p>}
                {props.buttons && (
					<>
						{props.buttons.map((button, index) => (
							<Link to={button.link} key={index}>
								<button className={button.style || 'btn_orange_fill'}>
									{button.text}
								</button>
							</Link>
						))}
					</>
				)}

                {/* { props.showSponsorsAndPartners && <SponsorAndPartnerLogos /> } */}
            </div>
			<div className="hero-image-wrapper">
				<img src={props.heroImage} alt={props.heroImageAlt} className="hero-image" />
			</div>
		</section>
    )
}

export default HeroTextAndImage;